import { defaultCountryCode } from '@components/country-code/constants';
import { BloodGroups } from '@types';
import { DropdownOption } from 'types/dropdown';
import { TabPill } from 'types/tabs';

import {
  IMemberFormFieldsState,
  MemberFormFields,
  MemberFormSections,
  MemberTransactionCard
} from './types';

const membersTableColumn = [
  { Header: 'Name', accessor: 'name', width: '18%' },
  { Header: 'Mobile No', accessor: 'phoneNumber', width: '17%' },
  { Header: 'Groups', accessor: 'groups', width: '25%' },
  { Header: 'Guardian Name', accessor: 'guardianName', width: '17%' },
  { Header: 'Total Due', accessor: 'totalDue', width: '18%' },
  { Header: 'Actions', accessor: 'actions', width: '5%' }
];

const defaultMemberFormData: IMemberFormFieldsState = {
  [MemberFormFields.ID]: '',
  [MemberFormFields.NAME]: '',
  [MemberFormFields.EMAIL]: '',
  [MemberFormFields.PRIMARY_COUNTRY_CODE]: defaultCountryCode,
  [MemberFormFields.PRIMARY_NUMBER]: '',
  [MemberFormFields.ALTERNATE_COUNTRY_CODE]: defaultCountryCode,
  [MemberFormFields.ALTERNATE_NUMBER]: '',
  [MemberFormFields.DATE_OF_BIRTH]: '',
  [MemberFormFields.BLOOD_GROUP]: '',

  [MemberFormFields.ADDRESS_LINE_1]: '',
  [MemberFormFields.ADDRESS_LINE_2]: '',
  [MemberFormFields.COUNTRY]: '',
  [MemberFormFields.CITY]: '',
  [MemberFormFields.STATE]: '',
  [MemberFormFields.PINCODE]: '',

  [MemberFormFields.GUARDIAN_NAME]: '',
  [MemberFormFields.ADMISSION_NUMBER]: '',
  [MemberFormFields.ADMISSION_DATE]: '',
  [MemberFormFields.IS_INSURED]: '',
  [MemberFormFields.COUNSELLOR_NAME]: ''
};

const bloodGroupOptions = Object.entries(BloodGroups).map(
  ([bloodGroupKey, bloodGroup]) => ({
    id: bloodGroupKey,
    value: bloodGroup,
    label: bloodGroup
  })
);

const isInuredOptions = [
  { value: 'Yes', key: 'true' },
  { value: 'No', key: 'false' }
];

const memberFormSidebarItems = [
  {
    id: MemberFormSections.PERSONAL_INFO,
    label: 'Personal Information'
  },
  {
    id: MemberFormSections.ADDRESS,
    label: 'Address'
  },
  {
    id: MemberFormSections.MORE_INFO,
    label: 'More Information'
  }
];

const defaultUserProfileTemplateHeaders = [
  'name',
  'primaryNumberCode',
  'primaryNumber',
  'altNumberCode',
  'altNumber',
  'email',
  'dateOfBirth',
  'guardianName',
  'admissionNumber',
  'admissionDate',
  'addressLine1',
  'addressLine2',
  'country',
  'state',
  'city',
  'pincode'
];

const memberExportColumnHeaders = [
  { key: 'name', label: 'Name' },
  { key: 'primary_number', label: 'Primary Number' },
  { key: 'alternate_number', label: 'Alternate Number' },
  { key: 'group', label: 'Group' },
  { key: 'email', label: 'Email' },
  { key: 'date_of_birth', label: 'Date of Birth' },
  { key: 'address', label: 'Address' },
  { key: 'guardian_name', label: 'Guardian Name' },
  { key: 'admission_number', label: 'Admission Number' },
  { key: 'admission_date', label: 'Admission Date' }
];

const templateUserProfileDummayData = [
  'John',
  '91',
  'XXXXXXXXXX',
  '91',
  'XXXXXXXXXX',
  'XXXXXX@gmail.com',
  '2024-02-14',
  'Doe',
  'A123',
  '2024-02-14',
  'Main street',
  'Near College',
  'India',
  'Karnataka',
  'Bangalore',
  '560001'
];

const memberTransactionSearchCategories: DropdownOption[] = [
  {
    id: 'orderId',
    value: 'merchantOrderId',
    label: 'Merchant Order ID'
  },
  {
    id: 'transactionId',
    value: 'transactionId',
    label: 'Transaction ID'
  }
];

const memberTabs: TabPill[] = [
  { id: 1, label: 'Member Details' },
  { id: 2, label: 'Transaction Details' },
  { id: 3, label: 'Attendance Details' }
];

//
const memberTransactionCards: MemberTransactionCard[] = [
  {
    id: 'total_due_amount',
    title: 'Total Due',
    value: 0,
    // icon: 'due-icon',
    // bgGradient:
    //   'bg-gradient-to-tr from-cofeeNeutral1 via-cofeeNeutral1 to-cofeeRed1',
    className: '!border-b-2 !border-b-cofeeRed7'
  },
  {
    id: 'total_collected_amount',
    title: 'Collected',
    value: 0,
    // icon: 'collected-icon',
    // bgGradient:
    // 'bg-gradient-to-tr from-cofeeNeutral1 via-cofeeNeutral1 to-cofeePrimary2',
    className: '!border-b-2 !border-b-cofeePrimary6'
  },
  {
    id: 'total_unsettled_amount',
    title: 'To be settled',
    value: 0,
    // icon: 'toBeSettled-icon',
    // bgGradient:
    //   'bg-gradient-to-tr from-cofeeNeutral1 via-cofeeNeutral1 to-cofeeYellow1',
    className: '!border-b-2 !border-b-cofeeYellow7'
  }
];

export const MAX_MEMBER_UPLOAD_ROWS = 500;

export {
  bloodGroupOptions,
  defaultMemberFormData,
  defaultUserProfileTemplateHeaders,
  isInuredOptions,
  memberExportColumnHeaders,
  memberFormSidebarItems,
  membersTableColumn,
  memberTabs,
  memberTransactionCards,
  memberTransactionSearchCategories,
  templateUserProfileDummayData
};
